<template>
  <div>
    <div class="list7" v-if="list && list.length > 0">
      <div
        class="item"
        :class="'bg' + index"
        v-for="(item, index) in list"
        :key="index"
        @click="handleClick(item)">
        <div class="content">
          <div class="content">
            <div class="name up">{{ item.name }}</div>
            <div class="date">
              <span v-if="item.type === 1"
                >{{ item.activity_count }}
                <span v-if="item.activity_count > 1">{{
                  $t('add.games')
                }}</span>
                <span v-else>{{ $t('add.game') }}</span>
                {{ $t('inprogress') }}</span
              >
              <span
                v-else-if="
                  item.type === 2 ||
                  item.type === 11 ||
                  item.type === 12 ||
                  item.type === 14 ||
                  item.type === 15
                ">
                {{ item.started_at }} - {{ item.ended_at }}
              </span>
              <span v-else>{{ $t('accountpage.text20') }}</span>
            </div>
            <div class="tag" v-if="item.tag">{{ item.tag }}</div>
          </div>
        </div>
      </div>
    </div>
    <mt-popup
      v-model="popupVisible"
      position="bottom"
      :closeOnClickModal="false">
      <div class="pop-box buy" v-if="popType === 'comming'">
        <div class="pop-title"></div>
        <div class="result-box">
          <div class="h icons comming">{{ $t('accountpage.text20') }}</div>
          <div class="de">{{ $t('add.text81') }}</div>
        </div>
        <el-button
          class="el-button--white block"
          style="margin-top: 0.3rem"
          @click="
            () => {
              this.popupVisible = false
            }
          "
          >{{ $t('ok') }}</el-button
        >
      </div>
    </mt-popup>
  </div>
</template>
<script>
import { postGames } from '@/api/user'

export default {
  components: {},
  props: {
    from: {
      type: String,
      default: () => 'user'
    },
    postGames: {
      type: Function,
      default: () => {}
    }
  },
  data() {
    return {
      list: null,
      popupVisible: false,
      popType: null
    }
  },
  methods: {
    init() {
      postGames().then((res) => {
        this.list = res.data
      })
    },
    handleClick(item) {
      console.log(item)
      if (item.status === 1) {
        this.$toast({ message: this.$t('new.text78') })
      } else {
        if (item.url) {
          if (this.from === 'user') {
            this.handleRoute('/user/activity?rec_code=' + item.url)
          } else {
            this.handleRoute('/babe/actdetail?rec_code=' + item.url)
          }
        } else if (item.type === 1) {
          if (this.from === 'user') {
            this.handleRoute('/user/actlist')
          } else {
            this.handleRoute('/babe/actlist')
          }
        } else if (item.type === 11) {
          if (this.from === 'user') {
            this.handleRoute('/user/quizdetail')
          } else {
            this.handleRoute('/babe/quizdetail')
          }
        } else if (item.type === 12) {
          if (this.from === 'user') {
            this.handleRoute('/user/votelist')
          } else {
            this.handleRoute('/babe/votelist')
          }
        } else if (item.type === 14) {
          if (this.from === 'user') {
            this.handleRoute('/user/eventlist')
          } else {
            this.handleRoute('/babe/eventlist')
          }
        } else if (item.type === 15) {
          if (this.from === 'user') {
            this.handleRoute('/user/spacelist')
          } else {
            this.handleRoute('/babe/spacelist')
          }
        } else {
          this.popType = 'comming'
          this.popupVisible = true
        }
      }
    },
    handleRoute(path, params) {
      if (params) {
        this.$router.push({ path: path, query: params })
      } else {
        this.$router.push({ path: path })
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/GamesBox.vue